//#region lib/utils/data.ts
function e(e) {
	return Object.entries(e).map(([e, t]) => ({
		key: e,
		value: t
	}));
}
function t(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
export { t as mergeClassName, e as toEntries };
